module.exports = __webpack_public_path__ + "d06948a464eb60aa65d7012ba3c2b71a.pdf";